import { z } from "zod";

export const DrasticRequestSchema = z.object({
  captureId: z.number().positive().min(1),

  drasticDId: z.number(),
  drasticRId: z.number(),
  drasticAId: z.number(),
  drasticSId: z.number(),
  drasticTId: z.number(),
  drasticIId: z.number(),
  drasticCId: z.number(),

  eppnaId: z.number(),
});

export type DrasticRequest = z.infer<typeof DrasticRequestSchema>;
